import React from "react";
import { RaisedButton, CircularProgress, MenuItem } from "material-ui";
import Helmet from "react-helmet";

import TicketList from "./partials/ticket-list/ticket-list.jsx";
import LinkLike from "./partials/link-like.jsx";
import CogButtonMenu from "./partials/cog-button-menu.jsx";
import SmsTicketsWidget from "./partials/sms-tickets-widget.jsx";

import { formatInsertables } from "../util";
import { isSundanceMobileMode } from "../utils/AppUtil";

import connectToStores from "alt-utils/lib/connectToStores";
import PersonStore from "../stores/PersonStore";
import TicketStore from "../stores/TicketStore";
import TicketActions from "../actions/TicketActions";

@connectToStores
class Tickets extends React.Component {
  static getStores() {
    return [PersonStore, TicketStore];
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object.isRequired,
      tenant: React.PropTypes.object,
      appSettings: React.PropTypes.object,
      isLarge: React.PropTypes.bool
    };
  }

  static getPropsFromStores() {
    var props = TicketStore.getState();
    props.isLoggedIn = PersonStore.getState().isLoggedIn;
    return props;
  }

  static componentDidConnect(props, context) {
    // Don't redirect if transfer query string is passed, since this means accept-ticket-transfer is open.
    // Let accept-ticket-transfer handle the redirection instead.
    if (!PersonStore.isLoggedIn() && !props.location.query.transfer) {
      context.router.replace({
        pathname: "/login",
        query: { next: props.location.pathname },
        state: {}
      });
    }
  }

  componentDidMount() {
    TicketActions.fetchAll();
  }

  getStyles() {
    return {
      container: {
        padding: 10
      },
      intro: {
        padding: 15,
        fontSize: "12pt",
        lineHeight: 1.5,
        color: "rgba(0,0,0,0.54)"
      },
      noTickets: {
        padding: "30px 10px",
        textAlign: "center"
      }
    };
  }

  render() {
    var styles = this.getStyles();

    const isSundanceMobile = isSundanceMobileMode(this.context.tenant);

    if (!this.context.appSettings.mock_logged_in) {
      if (!this.props.hasUpdatedAll) {
        return (
          <div
            className="Eventive--tickets Eventive--tickets--loading"
            style={styles.noTickets}
          >
            {this.props.children
              ? React.cloneElement(this.props.children, {
                  appSettings: this.props.appSettings,
                  location: this.props.location
                })
              : undefined}
            <CircularProgress
              mode="indeterminate"
              size={119}
              thickness={7}
              style={{ margin: 10.5 }}
            />
          </div>
        );
      } else if (
        !this.props.tickets ||
        Object.keys(this.props.tickets).length === 0
      ) {
        return (
          <div
            className="Eventive--MyTicketsPage Eventive--tickets Eventive--tickets--noTickets"
            style={styles.noTickets}
          >
            {this.props.children
              ? React.cloneElement(this.props.children, {
                  appSettings: this.props.appSettings,
                  location: this.props.location
                })
              : undefined}
            <div style={{ fontSize: "11pt", marginBottom: 10 }}>
              {this.context.tenant.my_tickets_no_tickets
                ? formatInsertables(
                    this.context.tenant.my_tickets_no_tickets.replace(
                      /\n/g,
                      "{{newline}}"
                    ),
                    {
                      newline: () => <br />,
                      link: (href, label) => (
                        <a href={href} target="_blank">
                          {label}
                        </a>
                      )
                    }
                  )
                : "You don't have any tickets."}
            </div>
            <RaisedButton
              primary={true}
              label={`Browse the ${this.context.tenant.display_schedule}`}
              onClick={() => this.context.router.push("/schedule")}
            />
          </div>
        );
      }
    }

    let sundancePhysicalTickets = {};
    if (this.props.tickets && isSundanceMobile) {
      let keys = Object.keys(this.props.tickets);
      for (let x=0; x < keys.length; x++) {
        if (!this.props.tickets[keys[x]].event.is_virtual) {
          sundancePhysicalTickets[keys[x]] = this.props.tickets[keys[x]];
        }
      }
    }

    return (
      <div
        className="Eventive--tickets Eventive--tickets--hasTickets"
        style={styles.container}
      >
        <Helmet title="My tickets" />
        {
          this.props.children
            ? React.cloneElement(this.props.children, {
                appSettings: this.props.appSettings,
                location: this.props.location
              })
            : undefined /* For ticket overlay */
        }
        <div style={styles.intro}>
          <CogButtonMenu style={{ float: "right" }}>
            <MenuItem
              style={{ cursor: "pointer" }}
              key="download"
              onClick={() => TicketActions.downloadPdf()}
              primaryText="Download all tickets as PDF"
            />
          </CogButtonMenu>
          {formatInsertables(
            this.context.tenant.my_tickets_description.replace(
              /\n/g,
              "{{newline}}"
            ),
            {
              newline: () => <br />,
              link: (href, label) => (
                <a href={href} target="_blank">
                  {label}
                </a>
              )
            }
          )}
          {this.context.isLarge ? <SmsTicketsWidget /> : null}
        </div>
        <TicketList tickets={isSundanceMobile ? sundancePhysicalTickets : this.props.tickets} />
      </div>
    );
  }
}

export default Tickets;



// WEBPACK FOOTER //
// ./src/app/components/tickets.jsx